import React from 'react';

// Desktop "Find person" box above the add-guest form. Logic: usePeopleSearch (vm.people).
export default function PeopleSearchDesktop({ vm }) {
  const { q, setQ, results, loading, pick } = vm.people;
  return (
    <div className="people-search">
      <input type="search" value={q} onChange={e => setQ(e.target.value)}
        placeholder="🔍 Find a person already known — name or number (guests of all events + your synced contacts)" />
      {(loading || results.length > 0 || q.trim().length >= 2) && (
        <div className="people-search-results">
          {loading && <div className="muted">Searching…</div>}
          {!loading && results.length === 0 && <div className="muted">Nobody found — type the details below.</div>}
          {results.map(p => (
            <button key={p.key} type="button" onClick={() => pick(p)}>
              <strong>{[p.Surname, p.GuestName].filter(Boolean).join(' ')}</strong>
              <span>{p.MobileNumber || '—'}</span>
              <span className="muted">{p.note}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
